import { render, staticRenderFns } from "./OrderShipmentLabelsList.vue?vue&type=template&id=07c2caf5"
import script from "./OrderShipmentLabelsList.vue?vue&type=script&lang=js"
export * from "./OrderShipmentLabelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports